import { inject, Injectable, signal } from "@angular/core";
import { AwardFuncData, AwardInsertValues, EventTypeId } from "@interfaces";
import { FuncService } from "../../../../../../../services";

@Injectable({ providedIn: 'root' })
export class AwardEditorDialogDataService {

	public dialogData = signal<AwardFuncData | undefined>(undefined);
	private func = inject(FuncService);
	public awardNameIds = signal<number[]>([]);
	public decidingRoleIds = signal<number[]>([]);

	public async resetDialogData() {
		this.dialogData.set(undefined);
	}

	public async getAwardNamesAndDecidingRoles() {
		const data = await this.func.award.getEventTypeSpecificAwardAndDecidingRole({ eventTypeId: EventTypeId.AccShowcase });
		this.awardNameIds.set(data.awardNameIds);
		this.decidingRoleIds.set(data.decidingRoleIds);
	}

	public async getAwardDetails(awardId: number) {
		const data = await this.func.award.getDetailsById({ awardId });
		this.dialogData.set(data);
	}

	public async saveAwardDetails(values: AwardInsertValues) {
		await this.func.award.addAward({ values });
	}

	public async updateAward(awardId: number, value: number, notes: string) {
		await this.func.award.updateAward({ awardId, value, notes });
	}

}